import React from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

// Keyed by gate.status.tone; a toned status replaces the "Return approvals status" label.
const STATUS_BUTTON_STYLES = {
  warning: { className: 'return-approval-status-warning', icon: 'clock' },
  error: { className: 'return-approval-status-error', icon: 'close-circle-filled' },
  success: { className: 'return-approval-status-success', icon: 'check-circle-filled' }
};

// Send for approval + approval status for a gated VAT return (ESF-1052).
// `gate` comes from utils/returnApprovalConfig.getApprovalGate.
const ReturnApprovalControls = ({ gate, isSending = false, sendDisabledTooltip = '', onSendForApproval, onGoToReturnApprovals }) => {
  const canSend = gate.canSend && !isSending;
  const { status } = gate;
  const statusStyle = status && STATUS_BUTTON_STYLES[status.tone];
  const statusButtonClassName = ['secondary', 'ml10', statusStyle?.icon && 'icon-leading', statusStyle?.className]
    .filter(Boolean).join(' ');
  return (
    <>
      <ReadOnlyWrapper>
        <button className="secondary ml10" onClick={onSendForApproval} disabled={!canSend}
          title={canSend ? undefined : sendDisabledTooltip} data-testid="send-for-approval-btn">
          <LanguageStringResolver string={gate.isResend ? 'filingPage_ReturnApproval_ResendBtn' : 'filingPage_ReturnApproval_SendBtn'} />
        </button>
      </ReadOnlyWrapper>
      <button className={statusButtonClassName} onClick={onGoToReturnApprovals} excludeFromReadonly={true} data-testid="return-approvals-status-btn">
        {statusStyle?.icon && <s-icon name={statusStyle.icon} aria-hidden="true"></s-icon>}
        {statusStyle
          ? <LanguageStringResolver string={status.key} params={status.params} />
          : <LanguageStringResolver string='filingPage_ReturnApproval_StatusBtn' />}
      </button>
    </>
  );
};

export default ReturnApprovalControls;
